import { DeleteForever } from '@mui/icons-material'
import { Button } from '@mui/material'

interface DeleteButtonProps {
  disabled?: boolean
  name: string
  onDelete: () => void
}

export default function DeleteButton({ disabled, name, onDelete }: DeleteButtonProps) {
  return (
    <Button
      color='error'
      disabled={disabled}
      endIcon={<DeleteForever />}
      onClick={() => {
        if (window.confirm(`Are you sure you want to delete this ${name}? This action cannot be undone.`)) {
          onDelete()
        }
      }}
      variant='text'
    >
      DELETE
    </Button>
  )
}
